"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.experimental_createTheme = void 0;
const experimental_createTheme = (appearance) => {
    // Placeholder method that might hande more transformations in the future
    return { ...appearance, __type: 'prebuilt_appearance' };
};
exports.experimental_createTheme = experimental_createTheme;
